
angular.module("swapick")
.factory('ReloadControllers', ReloadControllers);

function ReloadControllers() {
  const svc = {};

  const controllersCache = {};

  svc.notifyReload = (name) => {
    const names = _.isArray(name) ? name : [name];
    _.forEach(names, notifyName => {
      controllersCache[notifyName] = true;
    });
  };

  svc.whenReload = (name, callback) => {
    if (controllersCache[name]) {
      controllersCache[name] = false;
      callback(name);
    }
  };

  return svc;
}



// WEBPACK FOOTER //
// ./src/services/reload-controllers-service.js